<template>
  <div>
    <TwTable
      :searchData="searchData"
      :tableData="tableData"
      :tableConfig="tableConfig"
      @resetBtn="resetBtn"
      :pageConfig="pageConfig"
      :buttonList="buttonList"
      @btnCallFunction="callFunction"
      @handleCellClick="handleCellClick"
      @handleCurrentChange="handleCurrentChange"
      @handleSelectCheckbox="handleSelectCheckbox"
      @searchChange="searchChange"
      @handleSizeChange="handleSizeChange"
      @getTableEle="getTableEle"
      @handleSelsChange="handleSelsChange"
      @handleOperateEvent="handleOperateEvent"
    >
        <template v-slot:inventoryStatus>
        <el-select
          multiple
          filterable
          v-model="filters.inventoryStatus"
          placeholder="请选择"
          collapse-tags
        >
          <el-option
            v-for="item in inventoryStatusList"
            :label="item.inventoryStatusText"
            :value="item.inventoryStatusId"
            :key="item.inventoryStatusId"
          ></el-option>
        </el-select>
      </template>
      <template v-slot:tdate>
        <el-date-picker
          v-model="filters.tdate"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd"
        >
        </el-date-picker>
      </template>
      <template v-slot:realName>
        <el-select
          multiple
          v-model="filters.realName"
          filterable
          placeholder="请选择"
          collapse-tags
        >
          <el-option
            v-for="item in userList"
            :label="item.realName"
            :value="item.realName"
            :key="item.realName"
          ></el-option>
        </el-select>
      </template>
    </TwTable>

    <!-- 装车单 -->
    <!-- <el-dialog
      id="completeDialog"
      title="移库单"
      :visible.sync="addStockChangeVisible"
      width="90%"
      top="70px"
      style="text-align: center"
    >
      <div id="completeDiv">
        <iframe
          :src="completeTask"
          height="700"
          width="100%"
          style="border: none"
        ></iframe>
      </div>
    </el-dialog> -->
    <LogDialog
      :logPageConfig="logPageConfig"
      :showLog="showLog"
      :requestData="{ businessType: 29, businessCode: currentRow.loadCarNo }"
      :requestApi="'/WareHouse/BusinessLogServices'"
      :requestMethod="'get'"
      v-if="showLog"
      @showDialog="showDialog"
    ></LogDialog>
  </div>
</template>
<style>
figure {
  page-break-inside: avoid;
}
.viewer-list > li {
  width: 80px;
}
.viewer {
  display: none;
}
.printTitle {
  font-size: 16px;
  padding-top: 5px;
}

.printTable th,
.printTable td {
  color: #000;
  border-right: 1px solid #000 !important;
  border-bottom: 1px solid #000 !important;
}
</style>
<script>
import {
  getInventoryInfoList,
  approvedInventory,
  inventoryInfoAsyncOut,
} from "@/api/InventoryInfo/index.js";
import { getButtonList } from "../../promissionRouter";
import TwTable from "../../components/TwTable/TwTable";
import { TwTable_mixins } from "../../components/TwTable/mixins";
import { thereAre } from "util/util";
import LogDialog from "../../components/TwTable/components/logDialog";
import { getOperatorInfo } from "@/api/api.js";

export default {
  components: { LogDialog, TwTable },
  mixins: [TwTable_mixins],
  data() {
    return {
      userList: [],
      inventoryStatusList:[],
      printObj: {},
      tableConfig: {
        showResetButton: true,
        showSelection: true, // 显示多选框
        showRadio: true, // 显示单选框
        showIndex: false, // 显示序号
        loading: false, // 显示loading状态
        showPage: true, // 显示分页
        size: "medium", // table的尺寸  medium / small / mini
        showOperate: true, // 显示操作栏
        operate: {
          //操作栏配置
          align: "center",
          options: [
            {
              name: "日志",
              size: "small",
              type: "text",
              event: "getbusinessLoglist", // 操作的事件名
            },
          ],
        },
        column: [
          // 表格列配置

          {
            prop: "storage",
            label: "库位",
            align: "center",
            sortable: true,
            minWidth: "150",
          },
          {
            prop: "scanCode",
            label: "托唛",
            align: "center",
            sortable: true,
            minWidth: "200",
          },
          {
            prop: "orgCustomerNo",
            label: "参考单号",

            minWidth: "150",
          },
          {
            prop: "orgReceiptNo",
            label: "进仓单号",
            minWidth: "150",
          },
          {
            prop: "boxCount",
            label: "盘点箱数",
            align: "center",
            sortable: true,
            minWidth: "100",
          },
          {
            prop: "inventoryStatusText",
            label: "状态",
            align: "center",
            sortable: true,
            minWidth: "100",
          },
          {
            prop: "allBoxCount",
            label: "在库总件数",
            align: "center",
            sortable: true,
            minWidth: "100",
          },
          {
            prop: "createUser",
            label: "操作人",
            align: "center",
            minWidth: "100",
          },
          {
            prop: "createTimeText",
            label: "操作时间",
            align: "center",
            sortable: true,
            minWidth: "140",
          },
        ],
      },
      addStockChangeVisible: false,
      completeTask: "/StorageChange/AddStorageChange",
      searchData: {
        //搜索列配置
        search: [
          {
            type: "input",
            key: "storage",
            label: "库位",
            placeholder: "多个库位用逗号分开查询",
            clearable: true,
            width: 150,
          },
          {
            type: "input",
            key: "referenceNo",
            label: "参考单号",
            placeholder: "多个参考单号用逗号分开查询",
            clearable: true,
            width: 150,
          },
          {
            type: "select",
            key: "inventoryStatus",
            prop: "inventoryStatus",
            label: "状态",
            multiple: true,
            slot: true,
            placeholder: "",
            option: this.inventoryStatusList,
            width: 150,
          },
          {
            type: "select",
            key: "realName",
            prop: "realName",
            label: "操作人",
            multiple: true,
            slot: true,
            placeholder: "",
            option: this.userList,
            width: 150,
          },
          {
            key: "tdate",
            prop: "tdate",
            slot: true,
            label: "操作时间",
            hideLabel: true,
          },
        ],
        ///高级搜索配置
        moreSearch: [],
      },
      buttonList: [],
      Importtext: "",
      progressPercent: 0,
      progressFlag: true,
    };
  },

  created() {
    // 监听子组件的关闭事件
    window.addEventListener(
      "message",
      () => {
        this.closeSelf();
        this.closeReviewdialogVisible();
      },
      false
    );
  },
  methods: {
    resetBtn() {
      this.filters = {};
    },
    inited(viewer) {
      this.$viewer = viewer;
    },

    //文件上传前验证
    onBeforeUploadExcel(file) {
      console.log(file);
      var testmsg = file.name.substring(file.name.lastIndexOf(".") + 1);
      const extension = testmsg === "xls";
      const extension2 = testmsg === "xlsx";
      // const isLt2M = file.size / 1024 / 1024 < 10
      if (!extension && !extension2) {
        this.$message({
          message: "导入文件只能是 xls、xlsx格式!",
          type: "error",
        });
      }

      return extension || extension2;
    },
    closeSelf() {
      // 关闭当前弹框
      this.addStockChangeVisible = false;
      this.initTable();
    },
    callFunction(item) {
      if (item.name === "查询") {
        this.$set(this.pageConfig, "pageIndex", 1);
        this.newfilters = JSON.parse(JSON.stringify(this.filters));
        this.initTable.apply(this, item);
      } else {
        this[item.func].apply(this, item);
      }
    },
    // 弹出添加移库单
    addTaskdialog() {
      this.addStockChangeVisible = true;
    },

    ApprovedData() {
      let row = this.selectRows.rows;
      if (row == null || row.length == 0) {
        this.$message({
          message: "请选择数据！",
          type: "error",
        });
        return;
      }
      var that = this;
      var tfInventoryScanInfoIDs = this.selectRows.rows
        .map((item) => item.tfInventoryScanInfoID)
        .join(",");
      approvedInventory({
        TFInventoryScanInfoIDs: tfInventoryScanInfoIDs,
      }).then((res) => {
        if (res.data.success) {
          this.$message({
            message: res.data.msg,
            type: "success",
          });
          this.initTable();
        } else {
          this.$message({
            message: res.data.msg,
            type: "error",
          });
        }
      });
    },
    //查询日志
    getbusinessLoglist(row) {
      this.currentRow = row;
      this.showLog = true;
    },
    handleExport() {
      const loading = this.$loading({
        lock: true,
        text: "导出中，请稍等",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.5)",
      });

      const { storage, referenceNo, tdate,realName,inventoryStatus } = this.newfilters;

      let para = {
        page: this.pageConfig.pageIndex,
        pageSize: this.pageConfig.pageSize,
        realName: thereAre(realName),
        inventoryStatus: thereAre(inventoryStatus),
        storage,
        scanCode: referenceNo,
      };
      if (tdate != null && tdate != "null" && tdate != "") {
        para.StartDate = tdate[0];
        para.EndDate = tdate[1];
      }
      inventoryInfoAsyncOut(para).then((res) => {
        loading.close();
        if (res.data.success) {
          var data = res.data.response;
          if (data != null) {
            var arr = data.fileData.split(",");
            var mime = arr[0].match(/:(.*?);/)[1];
            var bstr = atob(arr[1]);
            var n = bstr.length;
            var u8arr = new Uint8Array(n);
            while (n--) {
              u8arr[n] = bstr.charCodeAt(n);
            }
            var blob = new Blob([u8arr], { type: mime });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            let fileName = data.fileName;
            a.download = decodeURIComponent(fileName);
            a.click();
            window.URL.revokeObjectURL(url);
          }
        } else {
          this.$message({
            message: res.data.msg,
            type: "error",
          });

          return;
        }
      });
    },
    //查询列表
    initTable() {
      const { storage, referenceNo, tdate,realName,inventoryStatus } = this.newfilters;

      let para = {
        page: this.pageConfig.pageIndex,
        pageSize: this.pageConfig.pageSize,
        realName: thereAre(realName),
        inventoryStatus: thereAre(inventoryStatus),
        storage,
        scanCode: referenceNo,
      };
      if (tdate != null && tdate != "null" && tdate != "") {
        para.StartDate = tdate[0];
        para.EndDate = tdate[1];
      }
      this.tableConfig.loading = true;
      this.tableConfig.showPage = false;
      getInventoryInfoList(para).then((res) => {
        const { total, pageData, pageIndex, pageSize } = res.data.response;

        this.$set(this.pageConfig, "total", total);
        this.$set(this.pageConfig, "pageIndex", pageIndex);
        this.$set(this.pageConfig, "pageSize", pageSize);
        this.tableData = pageData;
        this.tableConfig.loading = false;
        this.tableConfig.showPage = true;
      });
    },

    //单选选中复选框
    handleCellClick(row, column, event) {
      this.tableEle.toggleRowSelection(row);
    },
    //加载基础资料
    getBasicdatalist() {
      let user = JSON.parse(window.localStorage.user);
    },
  },

  mounted() {
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];

    this.buttonList = getButtonList(this.$route.path, routers);
    this.getBasicdatalist();
    getOperatorInfo().then((res) => {
      this.userList = res.data.response;
    });
    this.inventoryStatusList = [
  ...this.inventoryStatusList,
  { inventoryStatusId: 10, inventoryStatusText: '草稿' },
  { inventoryStatusId: 20, inventoryStatusText: '已审核' }
];
  },
};
</script>

<style lang="less">
.content-az {
  overflow-x: hidden;
}
.dialogClass {
  .el-dialog {
    .el-dialog__body {
      //border-top: 1px solid #dcdfe6;
      //border-bottom: 1px solid #dcdfe6;
      max-height: 2000px !important;
      min-height: 500px;
      overflow-y: hidden;
    }
  }
  .el-dialog.is-fullscreen {
    max-height: 2000px !important;
    min-height: 500px;
  }
}
</style>
<style type="text/css" media="print">
@page {
  margin-top: 5mm;
  margin-bottom: 9mm;
  padding-top: 5mm;
}
@media print {
  div.content {
    page-break-after: always;
  }
}
</style>